import { initLiveList } from '../../shared/liveList.js';

// The permission matrix, the Handbuch's last chapter. Read-only, so this wires
// the search box and the area select and nothing else - no ACTIONS table,
// because no row does anything when clicked.
//
// initLiveList does its own guarding: it returns null when the region is not
// on this page, and wires nothing. So there is no handle to keep here, unlike
// the lists that call live.refresh() after a save.
export function initBerechtigungList() {
  initLiveList({
    results: 'berechtigung-list',
    // The chapter's own path, not the old /berechtigungen - that one answers
    // with a 301, and a refetch through a redirect would work but spend a
    // round trip on every keystroke.
    path: '/handbuch/berechtigungen',
    forms: ['berechtigung-filter', 'berechtigung-search']
  });
}
